import React from "react";
import OrganizationsPanel from "../components/organizationsPanel";

function OrganizationsPage() {
  return <OrganizationsPanel />;
}

OrganizationsPage.propTypes = {};
OrganizationsPage.defaultProps = {};

export default OrganizationsPage;
